import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Label } from './ui/label'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from './ui/form'
import { Input } from './ui/input'
import { Button } from './ui/button'
import { zodResolver } from '@hookform/resolvers/zod'

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList
} from './ui/command'
import { z } from 'zod'
import { useMutation, useQueryClient } from 'react-query'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { useLocation, useNavigate } from 'react-router-dom'
import { useToast } from './ui/use-toast'
import { ClipLoader } from 'react-spinners'
import { cn } from '../lib/utils'
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover'
import { Check, ChevronsUpDown } from 'lucide-react'
import {
  useCheckClientLocations,
  useGetAllClients,
  useGetClientProducts
} from '../migration-api/api-hooks/clients'
// import { checkClientLocations } from '../migration-api/api-services/clients'
import { useGenerateSSCC } from '../migration-api/api-hooks/serialization'
function SsccModal ({ latitude, longitude }) {
  const axiosPrivate = useAxiosPrivate()

  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const location = useLocation()
  const { toast } = useToast()
  //
  const [openClient, setOpenClient] = useState(false)
  const [selectedClientKey, setSelectedClientKey] = useState()
  const [readpoint, setReadpoint] = useState([])
  const [prodName, setProdName] = useState()
  const [prods, setProds] = useState([])
  const [selectedClientId, setSelectedClientId] = useState('')
  const [selectedEmail, setSelectedEmail] = useState('')

  const formSchema = z.object({
    clientId: z.string({
      message: 'This field is required'
    }),
    gtin: z.string({
      message: 'This field is required'
    }),
    readpoint: z.string({
      message: 'This field is required'
    }),
    qty: z.string({
      message: 'This field is required'
    }),
    tag: z.string({
      message: 'This field is required'
    })
  })
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      clientId: '',
      gtin: '',
      readpoint: '',
      qty: '',
      tag: ''
    }
  })
  

  const { generateSSCC, isLoading: isGeneratingSSCC } = useGenerateSSCC({
    onSuccess: data => {
      toast({
        variant: 'success',
        title: 'Success',
        description: data?.message || 'SSCC labels generated successfully'
      })
      // Reset form after success
      form.reset()
      setProdName('')
      setSelectedClientId('')
      setSelectedEmail('')
      setReadpoint([])
      setProds([])
    },
    onError: error => {
      toast({
        variant: 'destructive',
        title: 'Error',
        description:
          error?.response?.data?.message || 'Failed to generate SSCC labels'
      })
    }
  })

  const onsubmit = data => {
    // Validate charset and mode combination
    if (data.charSet === 'alpha-numeric' && data.mode === 'seq') {
      toast({
        variant: 'destructive',
        title: 'Error',
        description:
          'Invalid selection: Alpha-numeric cannot be used with Sequential mode'
      })
      return
    }

    console.log('GTIN:', data.gtin)

    // Extract prodId from gtin field (format: "gtin,prodId,prodName")
    const gtinParts = data.gtin.split(',')
    const prodId = gtinParts[1]

    const payload = {
      clientId: parseInt(data.clientId),
      eventObjectParameter: {
        eventTime: new Date().toISOString(),
        recordTime: new Date().toISOString(),
        timeZone: '+01:00',
        latitude: latitude,
        longitude: longitude,
        readPoint: data.readpoint,
        bizStep: 'urn:epcglobal:cbv:bizstep:encoding',
        disposition: 'urn:epcglobal:cbv:disp:active'
      },
      gtin: data.gtin.substring(0, data.gtin.indexOf(',')),
      clientKey: data.clientKey,
      qty: parseInt(data.qty),
      tag: data.tag,
      prodId: parseInt(prodId),
      // prodId: data.gtin.substring(
      //   data.gtin.indexOf(',') + 1,
      //   data.gtin.lastIndexOf(',')
      // ),

      prodName: data.gtin.substring(data.gtin.lastIndexOf(',') + 1)
    }
    generateSSCC(payload)
  }

  // const submitSSCC = async data => {
  //   const response = await axiosPrivate.post(`queues/sscc`, data)
  //   return response
  // }

  // Fetch all clients
  const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients()
  const allClients = clientsData?.data || []

  // Fetch client products (GET query - automatically fetches when selectedClientId changes)
  const { data: productsData, isLoading: isLoadingProducts } =
    useGetClientProducts(selectedClientId, {
      enabled: !!selectedClientId
    })

  // Update prods when productsData changes
  useEffect(() => {
    if (productsData) {
      console.log('Products loaded:', productsData)
      setProds(productsData?.data || [])
    }
  }, [productsData])

  // Check/fetch client locations (assuming this is a mutation/POST method)
  const { mutate: checkClientLocations, isLoading: isLoadingLocations } =
    useCheckClientLocations({
      onSuccess: data => {
        console.log('Locations loaded:', data)
        setReadpoint(data?.data?.locations || [])
      },
      onError: error => {
        console.error('Error loading locations:', error)
        toast({
          variant: 'destructive',
          title: 'Error',
          description: 'Failed to load locations'
        })
        setReadpoint([])
      }
    })

  // const { mutate, isLoading } = useMutation(
  //   variables => submitSSCC(variables),
  //   {
  //     onSuccess (data, variables, context) {
  //       toast({
  //         variant: 'success',
  //         title: 'Success',
  //         description: `${data.data.message}`
  //       })
  //       queryClient.invalidateQueries('user-notifications')
  //     },
  //     onError (error) {
  //       if (error.code === 'ERR_NETWORK') {
  //         navigate('/', { state: { from: location }, replace: true })
  //       } else if (error.response.status === 401)
  //         navigate('/', { state: { from: location }, replace: true })
  //       else {
  //         toast({
  //           variant: 'destructive',
  //           title: 'Error',
  //           description: `${error?.response?.data?.message}`
  //         })
  //       }
  //     }
  //   }
  // )

  const handleClientChange = (clientId, clientEmail) => {
    // console.log('Client selected, ID:', clientId)
    setSelectedClientId(clientId)
    setSelectedEmail(clientEmail)
    form.setValue('clientId', clientId)

    // Reset dependent fields
    form.setValue('gtin', '')
    form.setValue('readpoint', '')
    setProdName('')
    setReadpoint([])
    setProds([])

    // Fetch locations for this client (POST method with payload)
    checkClientLocations({ client_email: clientEmail })

    // Products will be fetched automatically by the query hook
    // since selectedClientId changed
  }

  return (
    <div>
      <div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onsubmit)} className='space-y-8'>
            <FormField
              control={form.control}
              name='clientId'
              render={({ field }) => (
                <FormItem className='flex flex-col'>
                  <FormLabel>Clients</FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant='outline'
                          role='combobox'
                          disabled={isLoadingClients}
                          className={cn(
                            'w-[100%] justify-between',
                            !field.value && 'text-muted-foreground'
                          )}
                        >
                          {isLoadingClients
                            ? 'Loading clients...'
                            : field.value
                            ? allClients?.find(
                                client => client?.id === parseInt(field.value)
                              )?.clientName
                            : 'Select client'}
                          <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className='w-[100%] p-0'>
                      <Command>
                        <CommandInput placeholder='Search client...' />
                        <CommandEmpty>No client found.</CommandEmpty>
                        <CommandGroup>
                          <CommandList>
                            {allClients.map(client => (
                              <CommandItem
                                value={client?.clientName}
                                key={client.id}
                                onSelect={() =>
                                  handleClientChange(
                                    client?.id.toString(),
                                    client?.email
                                  )
                                }
                              >
                                <Check
                                  className={cn(
                                    'mr-2 h-4 w-4',
                                    client.id === parseInt(field.value)
                                      ? 'opacity-100'
                                      : 'opacity-0'
                                  )}
                                />
                                {client.clientName}
                              </CommandItem>
                            ))}
                          </CommandList>
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name='readpoint'
              render={({ field }) => (
                <FormItem className='flex flex-col'>
                  <FormLabel>Locations</FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant='outline'
                          role='combobox'
                          className={cn(
                            'w-[100%] justify-between',
                            !field.value && 'text-muted-foreground'
                          )}
                        >
                          {field.value
                            ? readpoint?.find(loc => loc?.gln === field.value)
                                ?.address
                            : 'Select your location'}
                          <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className=' w-[100%] p-0'>
                      <Command>
                        <CommandInput placeholder='Search location..' />
                        <CommandEmpty>No locaton found.</CommandEmpty>
                        <CommandGroup>
                          {readpoint.map(loc => (
                            <CommandItem
                              value={loc?.gln}
                              key={loc?.gln}
                              onSelect={() => {
                                form.setValue('readpoint', loc?.gln)
                              }}
                            >
                              <Check
                                className={cn(
                                  'mr-2 h-4 w-4',
                                  loc?.gln === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              {loc?.address}
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name='gtin'
              render={({ field }) => (
                <FormItem className='flex flex-col'>
                  <FormLabel>GTINs</FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant='outline'
                          role='combobox'
                          className={cn(
                            'w-[100%] justify-between',
                            !field.value && 'text-muted-foreground'
                          )}
                        >
                          {prodName ? prodName : 'Select Gtin'}
                          <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className=' w-[100%] p-0'>
                      <Command>
                        <CommandInput placeholder='Search products....' />
                        <CommandEmpty>No GTIN found.</CommandEmpty>
                        <CommandGroup>
                          <CommandList>
                            {prods.map(prod => (
                              <CommandItem
                                value={`${prod.gtin},${prod.id},${prod.prodName}`}
                                key={prod?.id}
                                onSelect={() => {
                                  setProdName(prod.prodName)
                                  form.setValue(
                                    'gtin',
                                    `${prod.gtin},${prod.id},${prod.prodName}`
                                  )
                                }}
                              >
                                <Check
                                  className={cn(
                                    'mr-2 h-4 w-4',
                                    prod?.prodName === prodName
                                      ? 'opacity-100'
                                      : 'opacity-0'
                                  )}
                                />
                                {prod?.prodName}
                              </CommandItem>
                            ))}
                          </CommandList>
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className='flex gap-[10px]'>
              <FormField
                control={form.control}
                name='qty'
                render={({ field }) => (
                  <FormItem>
                    <Label>Volume</Label>
                    <FormControl>
                      <Input
                        className='flex-2'
                        type='number'
                        placeholder={'set volume'}
                        autoComplete='off'
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name='tag'
                render={({ field }) => (
                  <FormItem>
                    <Label>Tag</Label>
                    <FormControl>
                      <Input
                        className='flex-2'
                        type='text'
                        placeholder={'Set Tag'}
                        autoComplete='off'
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>

            <Button type='submit' disabled={isGeneratingSSCC}>
              {isGeneratingSSCC ? (
                <span className='mx-[20px]'>
                  <ClipLoader color='primary' size={20} />
                </span>
              ) : (
                <span>Submit</span>
              )}
            </Button>
          </form>
        </Form>
      </div>
    </div>
  )
}

export default SsccModal
